<template>
  <div>
    <!-- When Selection has entries, render a dropdown (no custom entry support) -->
    <QAutoComplete
      v-if="hasSelection"
      v-model="localValue"
      :label="label"
      :hint="hint"
      :persistentHint="!!hint"
      :list="selectionItems"
      textkey="text"
      valuekey="value"
      :rules="rules"
      :clearable="!definition.IsRequired"
      externaledit
    />

    <!-- When no Selection, show a read-only empty state -->
    <div v-else>
      <div class="mb-1">{{ label }}</div>
      <div v-if="hint" class="text-caption grey--text mb-1">{{ hint }}</div>
      <div class="text-caption grey--text mt-1">
        No selection options defined
      </div>
    </div>
  </div>
</template>

<script>
import QAutoComplete from "@/components/Inputs/QAutoComplete.vue";

export default {
  name: "QAIFieldStringListFixed",
  components: { QAutoComplete },
  props: {
    value: { type: [String, Array], default: "" },
    definition: { type: Object, required: true },
  },

  computed: {
    hasSelection() {
      return this.definition.Selection && Object.keys(this.definition.Selection).length > 0;
    },
    selectionItems() {
      if (!this.definition.Selection) return [];
      return Object.entries(this.definition.Selection).map(([key, val]) => ({
        value: key,
        text: val,
      }));
    },
    localValue: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
    label() {
      return this.definition.Description || this.definition.Name;
    },
    hint() {
      return this.definition.DefaultValue ? `Default: ${this.definition.DefaultValue}` : "";
    },
    rules() {
      return this.definition.IsRequired ? [v => !!v || `${this.definition.Name} is required`] : [];
    },
  },
};
</script>
